import React from "react";
import { Trans } from "react-i18next";
import Link from "@mui/material/Link";
// The download wording is the explicit consent and waiver of the cancellation
// right that consumer law requires before digital content is supplied (EPMS-2528).
const AcceptTermsOfPurchaseLabel = ({ askDigitalCancellationWaiver, onShowTermsOfPurchase, }) => {
    if (askDigitalCancellationWaiver) {
        return (React.createElement(Trans, null,
            "I accept the",
            " ",
            React.createElement(Link, { href: "javascript:void(0)", onClick: () => onShowTermsOfPurchase() }, "Terms of Purchase"),
            " ",
            "and expressly consent to the immediate supply of my digital photographs. I understand that I will lose my right to cancel the digital purchase once downloading begins."));
    }
    return (React.createElement(Trans, null,
        "I accept the",
        " ",
        React.createElement(Link, { href: "javascript:void(0)", onClick: () => onShowTermsOfPurchase() }, "terms of purchase")));
};
export default AcceptTermsOfPurchaseLabel;
